/* eslint-disable */
import Phaser from 'phaser';
import { store } from '../stores/mainStore';
import { i18n } from '../i18n';
import {Tips} from './Tips';
import {DiceHand} from './DiceHand';
import {DicePopper} from './DicePopper';
import {Cup} from './Cup';
import {BonusGame} from './BonusGame';
import {addHandName, strokeTextStyle} from './uiElements';

export class UI {
	constructor(mgr) {
		this.m = mgr;
		this.scene = this.m.scene;

		this.diceHand = new DiceHand(this.m);
		this.popper = new DicePopper(this.m, this.diceHand);
		this.cup = new Cup(this.m, this.diceHand);
		this.bonusGame = new BonusGame(this.m, this.diceHand);
		//this.betSelector = new BetSelector(this.m);

		this.goalArrow = null;
		this.goalArrowX = this.m.config.width / 2 - 480 * 0.3 * this.m.scaleFactor;
		this.goalArrowY = this.m.config.height * 0.18;
		this.defaultButtonHeight = 50 * 2;

		this.correctHandSound = 'sfx_good_hand';
		this.noHandSound = 'sfx_no_hand';
	}
	dodFontFamily = 'Jost'; 
	
	bumperDelay = 200;
	startBumperDelay = () => {
		console.log('8158 UI startBumperDelay')
		this.bumperPlaying = true;
		gameSetTimeout(() => {
			this.bumperPlaying = false;
		}, this.bumperDelay);
		this.bumperDelay = 150;
	};
	collisionStars = (x, y) => {
		if (!this.bumperPlaying) {
			var lilStars = this.scene.add.sprite(x, y, 'poof');
			lilStars.setDepth(2);
			this.m.playAudio('bumper');
			lilStars.anims.play('poof', true);
			this.startBumperDelay();
		}
	};
	
	makePulsate(obj, dur=750, size=1.15, repeat=true, complete = () => { return }) {
		//console.log('8158 UI makePulsate')
		let scale = obj.scaleX;
		return this.scene.tweens.add({
			targets: [obj],
			scale: scale * size,
			ease: 'Linear',
			duration: dur,
			repeat: (repeat ? -1 : 0),
			yoyo: true,
			onComplete: () => complete(),
		});
	}
	shadowTextStyle = (weight=700, fs=65) => ({
		font: weight + ' ' + fs +'px ' + window.manager.ui.dodFontFamily,
		fill: '#ffffff',  stroke: '#ff0000', strokeThickness: 0,
		shadow: { offsetX: 0, offsetY: 3, color: '#00000059', blur: 0, stroke: false, fill: true }
	})
	strokeTextStyle = (weight, fs) => ({
		font: weight + ' ' + fs +'px ' + window.manager.ui.dodFontFamily,
		fill: '#ffffff', stroke: '#6e2411', strokeThickness: 3,
		shadow: { offsetX: 0, offsetY: 3, color: '#00000059', blur: 0, stroke: false, fill: true }
	})
	createButton(_image, x, y, minWidth, height, text, pointerUpFunction, color='blue', iconLeft = '', iconRight='') {
		//console.log(' 3932 create button :: color =', color, 'text =', text, 'icon =', iconLeft, 'at', x, y, 'size =', minWidth, height)
		const assetH = 105;		// height of graphic asset
		const scaleH = 0.8* height / assetH;	// magic number to see buttons the same size as previous
		const fontSize = 50 * scaleH;
		const textStyle = {
			font: '800 ' + fontSize+'px '+ this.dodFontFamily,
			align: 'center',
			fill: '#ffffff',
			shadow: {offsetX: 0, offsetY: 4 *scaleH, color: '#00000059', fill:true}
		}
		const hiddenIcon = iconLeft === 'small_star.png';

		const leftPic = this.scene.add.sprite(0, 0, 'common', 'btn_'+color+'_left.png').setOrigin(1, 0.43).setScale(scaleH);
		const midlPic = this.scene.add.sprite(leftPic.getBounds().right, 0, 'common', 'btn_'+color+'_middle.png').setOrigin(0, 0.43).setScale(scaleH);
		const rightPic = this.scene.add.sprite(midlPic.getBounds().right, 0, 'common', 'btn_'+color+'_right.png').setOrigin(0, 0.43).setScale(scaleH);
		const contentContainer = this.scene.add.container(0, 0);
		let leftIcon, rightIcon;
		if(iconLeft !== '') {
			leftIcon = this.scene.add.sprite(0, 0, 'common', iconLeft)
				.setOrigin(0, 0.5).setScale(scaleH)
				.setAlpha(hiddenIcon ? 0 : 1);
			const leftIconShadow = this.scene.add.sprite(leftIcon.x, leftIcon.y + textStyle.shadow.offsetY, 'common', iconLeft)
				.setOrigin(leftIcon.originX, leftIcon.originY).setScale(leftIcon.scale)
				.setTintFill(0).setAlpha(hiddenIcon ? 0 : 0.35);
			contentContainer.add([leftIconShadow, leftIcon]);
		}
		const txt = this.scene.add.text(
			leftIcon ? leftIcon.getBounds().right + 5*scaleH : 0, 0, 
			(i18n.t(text) || text).toUpperCase(), textStyle)
			.setOrigin(0, 0.5);
		if(txt.getBounds().height >= assetH*scaleH) {		
			// two lines text
			txt.setScale(0.8 * assetH*scaleH / txt.getBounds().height);
		}
		contentContainer.add(txt);

		if(iconRight !== '') {
			rightIcon = this.scene.add.sprite(txt.getBounds().right + 5*scaleH, 0, 'common', iconRight)
				.setScale(scaleH).setOrigin(0, 0.5);
			const rightIconShadow = this.scene.add.sprite(rightIcon.x, rightIcon.y + textStyle.shadow.offsetY, 'common', iconRight)
				.setOrigin(rightIcon.originX, rightIcon.originY).setScale(rightIcon.scale)
				.setTintFill(0).setAlpha(0.35)
			contentContainer.add([rightIconShadow, rightIcon]);
		}

		rightPic.setX(Math.max(
			minWidth - leftPic.getBounds().width - rightPic.getBounds().width,
			rightPic.getBounds().left, 
			rightIcon ? rightIcon.getBounds().centerX + 0.25*rightIcon.getBounds().width
				: txt.getBounds().right)
		);
		midlPic.setDisplaySize(rightPic.getBounds().left - midlPic.getBounds().left, midlPic.displayHeight);
		contentContainer.setX(midlPic.getBounds().centerX - contentContainer.getBounds().width/2);

		const picContainer = this.scene.add.container(0, 0)
			.add([leftPic, midlPic, rightPic])
		const buttonContainer = this.scene.add.container(x, y).setDepth(4)
		buttonContainer.bkgs = picContainer.getBounds();
		buttonContainer.add([leftPic, midlPic, rightPic, contentContainer])
			//.add([picContainer, contentContainer])
			.iterate(ch => ch.setX(ch.x - midlPic.getBounds().width/2));

		buttonContainer.leftPic = leftPic;
		buttonContainer.midlPic = midlPic;
		buttonContainer.rightPic = rightPic;	//save for adding glow later
	
		const hitButton = this.scene.add.sprite(0, 0, 'common', 'btn_red_middle.png')
			.setDisplaySize(buttonContainer.getBounds().width *1.2, buttonContainer.getBounds().height *1.5)
			.setInteractive().setAlpha(0.02);
		buttonContainer.add(hitButton);

		hitButton.debounce = text === 'skip-practice' || text === 'extra-roll' ? false : true;
		hitButton.moveButton = true;
		hitButton.offScreen = false;
		hitButton.buttonPressed = false;
		hitButton.downButtonPressed = false;
		hitButton.oldContainerY = hitButton.offScreen ? (buttonContainer.y - (this.m.config.height/2)) : buttonContainer.y;
		hitButton.container = buttonContainer;

		hitButton.on('pointerdown', function (pointer) {
			if ((this.debounce === true && this.buttonPressed === true) || this.downButtonPressed === true) return;
			this.downButtonPressed = true;

			if (this.moveButton) this.container.y = this.oldContainerY + 5;
			else this.container.setAlpha(0.5);
			this.m.playAudio('poop');
		});
		hitButton.on('pointerout', function (pointer) {
			if (this.debounce === true && this.buttonPressed === true) return;
			if (this.moveButton) this.container.y = this.oldContainerY;
			else this.container.setAlpha(1.0);
			this.buttonPressed = false;
		});
		hitButton.on('pointerup', function (pointer) {
			if (this.debounce === true && this.buttonPressed === true) return;
			this.buttonPressed = true;

			if (this.moveButton) this.container.y = this.oldContainerY;
			else this.container.setAlpha(1.0);
			this.m.playAudio('pop');
			gameSetTimeout(pointerUpFunction, 150);
		});

		buttonContainer.hitButton = hitButton;
		return buttonContainer;
	}
	createTexts = (textKey, fs, styles) => {
		const txtArr = i18n.t(textKey).split('*');
		//console.log('8158 UI createTexts', textKey, 'fs =', fs, 'st =', styles)
		let lineBounds = new Phaser.Geom.Rectangle(0, 0, 0, 0);
		return txtArr.map(txt => {
			if(txt === 'p' || txt ==='br') {
				const dy = (txt === 'p' ? 0.5 : -0.1)*fs
				lineBounds.bottom += dy;
				return false
			} else {
				const textPart = (str, x, y, style = styles[0]) => this.scene.add.text(x, y, str, {
						font: '700 '+fs+'px ' + this.dodFontFamily, align: 'center', 
						fill: '#ffffff', stroke: '#6e2411', strokeThickness: 6,
						...style
					}).setOrigin(0);

				let partBounds = new Phaser.Geom.Rectangle(0, lineBounds.bottom, 0, 0);
				const parts = txt.split(/\[|\]/gi).map(str => {
					let res;
					if(str.startsWith('click')) {
						const txtName = str.split(' ').pop();
						res = textPart(i18n.t(txtName), partBounds.right, lineBounds.bottom)
							.setFill('#0000ff')
							.setInteractive({cursor: 'pointer'})
							.on('pointerup', () => { if(onClick)	onClick();})
					} else if(str.startsWith('pic')) {
						const picName = str.split(' ').pop();
						res = this.scene.add.image(partBounds.right, lineBounds.bottom, picName).setOrigin(0)
						res.setScale(1.7 * fs / res.height);
					} else if(str.startsWith('style')) {
						const arr = str.split(' ')
						const textStyle = styles[arr[1]] || {}
						res = textPart(i18n.t(arr[2]), partBounds.right, lineBounds.bottom, textStyle)
					} else {
						res = textPart(str, partBounds.right, lineBounds.bottom, styles[0] || {});
					}
					Phaser.Geom.Rectangle.MergeRect(partBounds, res.getBounds());
					return res;
				});

				parts.forEach(ch => {
					ch.x -= partBounds.width/2;
					ch.y += partBounds.height/2 - ch.getBounds().height/2
				});
				Phaser.Geom.Rectangle.MergeRect(lineBounds, partBounds);
				return parts
			}
		}).filter(Boolean)
	};
	createTextBox  = (textKey, styles=[{}], img='tutorial_box', picScale = 0.675, onClick = null) => {
		//console.log('8158 UI createTextBox', textKey)
		const tipPanel = this.scene.add.image(0, 0, img).setScale(picScale * this.m.scaleFactor);
		const placeBounds = Phaser.Geom.Rectangle.Scale(tipPanel.getBounds(), 0.9, 0.75);
		const calcTextBounds = arr => arr.reduce((rect, part) => Phaser.Geom.Rectangle.MergeRect(rect, part.getBounds()), new Phaser.Geom.Rectangle())

		let fontSize = 50;
		let lines = this.createTexts(textKey, fontSize, styles).flat(), bounds = calcTextBounds(lines);
		const scale = Math.min(placeBounds.width/bounds.width, placeBounds.height/bounds.height)
		lines.forEach(ch => ch.destroy())
		styles.forEach(style => {
			if(style.font) {
				const vals = style.font.split(" ")
				vals[1] = vals[1].slice(0,-2) * scale + 'px';
				style.font = vals.join(" ")
			}
			if(style.strokeThickness)
				style.strokeThickness *= scale
		})
		lines = this.createTexts(textKey, fontSize * scale, styles).flat();

		bounds = calcTextBounds(lines);
		lines.forEach(ch => ch.y -= bounds.height/2 + 0.04*tipPanel.getBounds().height);
		
		return [tipPanel, ...lines]
	}
	createTutorialBox(textKey, y, inTimeline = false, time = 200, pause = 0) {
		//console.log('8158 UI createTutorialBox', textKey, 'y =', y, 'text =', i18n.t(textKey))
		if(this.avaPanel)	this.avaPanel.destroy();
		this.avaPanel = this.scene.add.container(-this.m.config.width/2, y).setDepth(5);
		this.avaPanel.add(this.createTextBox(textKey, 
			[{}, {...strokeTextStyle(900, 50), strokeThickness: 4}]));
		const tweenConfig = {targets: [this.avaPanel], duration: time, 
			x: {start: -this.m.config.width/2, to: this.m.config.width/2},
			onStart: () => this.m.playAudio('Transitions_Movement'),
			completeDelay: pause
		}
		return inTimeline ? tweenConfig : this.scene.tweens.add(tweenConfig)
	}

	protoCreateTable() {
		const pushDownAmount = this.m.adjustY(45);
		const bounds = this.scene.matter.world.disableGravity()
			.setBounds(20, pushDownAmount, this.m.config.width - 40, this.m.config.height - 2*pushDownAmount, 200, false, false, false, true,)
		Object.values(bounds.walls).forEach(o => {if(o) o.label = 'bounds'});

		this.scene.matter.world.on('collisionstart', event => {
			event.pairs.forEach(pair => {
				const { bodyA, bodyB } = pair;
				if (bodyA.label === 'bounds' || bodyA.label === 'frameBound') {
					this.collisionStars(bodyB.position.x, bodyB.position.y);
				}
				if (bodyB.label === 'bounds' || bodyB.label === 'frameBound') {
					this.collisionStars(bodyA.position.x, bodyA.position.y);
				}
			});
		});
		
		const playfield = this.scene.add.image(this.m.config.width / 2, 0, 'gameBkg').setOrigin(0.5, 0).setInteractive()
		playfield.setScale(this.m.config.height / playfield.height);
		const bonusBkg = this.scene.add.image(this.m.config.width / 2, 0, 'bonusGameBkg').setOrigin(0.5, 0)
		bonusBkg.setScale(this.m.config.height / bonusBkg.height);
		const watermark = this.scene.add.image(this.m.config.width / 2, this.m.config.height/2, 'watermark').setOrigin(0.5);
		watermark.setScale(0.9* this.m.config.width / watermark.width);
		const playfieldFrame = this.scene.add.image(this.m.config.width / 2, pushDownAmount, 'playfieldFrame').setOrigin(0.5, 0).setDepth(2);
		playfieldFrame.setScale(this.m.config.width / playfieldFrame.width);
		const bonusFieldFrame = this.scene.add.image(this.m.config.width / 2, pushDownAmount, 'bonusFieldFrame').setOrigin(0.5, 0).setDepth(2);
		bonusFieldFrame.setScale(this.m.config.width / bonusFieldFrame.width);

		const pad = 500;
		const framePath = `-${pad} -${pad} -${pad} 2300 `+'0 2300 30 220 80 150 140 112 200 90 300 80 390 85 500 110 570 160 610 200 650 2300'+` ${650 + pad} 2300 ${650 + pad} -${pad}`
		const scaledPath = framePath.split(' ').map(v => (~~v + pad)*playfieldFrame.scale).join(' ');
		const verts = this.scene.matter.verts.fromPath(scaledPath);
		this.scene.matter.add.fromVertices(
			this.m.config.width/2 -50, 
			(this.m.config.height/2 - pad) /playfieldFrame.scale + 50,
			verts, { 
			ignoreGravity: true, label: 'frameBound',
			friction: 0.005, isStatic: true,
		}, false, 0.01, 10)

		if (this.m.sceneRestarting === false) {
			this.diceHand.create();
		} else {
			this.diceHand.reCreate();
		}
		this.diceHand.clearDiceOffScreen();
		this.popper.create();
		this.cup.create();
		this.bonusGame.create(bonusBkg, bonusFieldFrame);
		//this.betSelector.create();

		const underY = this.diceHand.getBottom() + 80
		const bkg = this.scene.add.image(0.5*this.m.config.width, underY + 5, 'score_bkg')
			.setOrigin(0.5).setDepth(10)
			.setDisplaySize(0.4* this.m.config.width, 100);
		const txt = addHandName(this.m.config.width/2, underY, 'try_again', 75, 0.3* this.m.config.width).setDepth(10)
		this.underDiceText = this.scene.add.group([bkg, txt]).setVisible(false)
	}
	onDiceInCup = () => {
		this.cup.hideCup();
		this.diceHand.diceStatus = 'resolved';
	}
	mini3Prematch = () => {
		if(store.custom.usePopper)
			this.popper.startRound();	// show logo dice, pop btn, enable
		else
			this.cup.appear(false)
	}
	protoUserPlay = () => {
		//this.betSelector.setEnable(true);
		//this.betSelector.setVisible(true);
		store.showBottomUI = true;
		store.showPatternButton = true;
		
		const showBetTip = () => Tips.showTip(Tips.NAMES.BET, 0.57 *this.m.config.height)
		if(!Tips.tipShown(Tips.NAMES.SPOT))
			Tips.showTip(Tips.NAMES.SPOT, 0.35* this.m.config.height, null, showBetTip)
		else if(!Tips.tipShown(Tips.NAMES.BET))
			showBetTip();
		
		if(store.custom.usePopper) {
			this.popper.showBtn(false);
			this.popper.btnEnable(true);
		} else {
			//this.scene.tweens.timeScale = 0.1; // slow animation for dev time
			if(!this.cup.isAtScreen)
				this.cup.appear(true);
			else 
				this.cup.enable();
		}
	}
	breakRoll() {
		this.cup.processCupPointerUp(true);
		this.diceHand.diceStatus = 'resolved';
		this.diceHand.clearDiceOffScreen();
	}
	startRolling() {
		console.log('4564 UI start rolling')
		this.tableClearing();
		if(store.custom.usePopper) 
			this.popper.animation();
		else {// smth for collision stars
			this.bumperDelay = 200;
			this.startBumperDelay();
		}
		//this.betSelector.setVisible(false);
		store.showBottomUI = false;
	}

	winBannerBack = null;
	winBanner = null;
	createWinBanner = handName => {
		this.winBannerBack = this.scene.add.sprite(this.m.config.width / 2, this.m.config.height, 'common', 'big_win_banner_x2.png')
			.setScale(this.m.oldAssetScaleFactor*0.5)
			.setDepth(3).setOrigin(0.5, 0.1)
		this.winBanner = addHandName(
			this.m.config.width/2, this.winBannerBack.getBounds().centerY - 15, 
			handName, 
			70, 500
		).setDepth(3);		
	}
	clearWinBanner = () => {
		this.winBannerBack?.destroy();
		this.winBanner?.destroy();
		this.underDiceText.setVisible(false)
	}
	showWinBanner = handName => {
		console.log('4564 show win banner :: hn=', handName)
		return {
			onStart: this.createWinBanner(handName),
			targets: [this.winBannerBack, this.winBanner], 
			duration: 200, ease: 'Back.easeOut',
			y: '+=' + (this.diceHand.getBottom() - this.m.config.height)
		}
	}
	tableClearing = () => {
		this.clearWinBanner();
		this.diceHand.unlockAllDice();
	}

	showLoseHand = () => {
		console.log('4564 UI lost hand :: txt =', this.underDiceText)
		this.scene.tweens.add({
			targets: this, duration: 500, val: {from: 0, to: 1},
			delay: 600,
			onStart: () => {
				this.m.playAudio('sfx_loose_hand');
				this.underDiceText.setVisible(true)
			},
			completeDelay: 200,
			onComplete: () => {this.m.gameState = 'endMatch'}
		})
	}
	showWinHand = () => {
		console.log('4564 UI show win hand anim')
		this.scene.tweens.timeline({ 
			delay: 100,
			onComplete: () => this.showScoreAnimations(),
		}).add({
			targets: this, duration: 500, val: {from: 0, to: 1},
			onComplete: () => {
				if(store.activeMatch.currentHand.match.length > 0)
					this.m.playAudio('twinkle');
				store.activeMatch.currentHand.match.forEach(ind => {
					this.diceHand.dice[ind].locked = true;
					this.diceHand.dice[ind].addFlair('flair')
				})
				this.diceHand.darkenUnlockedDice()
				store.curPattern = {...store.curPattern, winPlaces: store.activeMatch.currentHand.match};
			}
		}).add(this.showWinBanner(store.activeMatch.currentHand.handName))
		.play()
	}
	showScoreAnimations = () => {
		const baseScore = store.prize;
		const moveTime = 1000, fadeTime = 200, zoomTime = 200, pauseTime = 100;
		const hei = 100;
		const startY = this.winBannerBack.getBounds().bottom + hei/2;
		const bkg = this.scene.add.image(0.72*this.m.config.width, startY + 5, 'score_bkg')
			.setOrigin(0.5).setDepth(10).setAlpha(0)
			.setDisplaySize(0.45* this.m.config.width, hei);
		const txt = this.scene.add.text(0.77*this.m.config.width, startY, 
			i18n.t('score_coins').replace('*num*', store.truncateValue(baseScore)), {
				font: '500 '+ 0.5*hei +'px ' + this.dodFontFamily, align: 'center', 
		}).setDepth(10).setOrigin(0.5).setAlpha(0)
		const coin = this.scene.add.image(0.55*this.m.config.width, startY, 'coin').setDepth(10).setScale(0)
		coin.setScale(0.9 * hei / coin.height)

		const flow = this.scene.tweens.timeline({
				completeDelay: 300,
				onComplete: () => this.m.gameState = 'anticipation'
			})
			.add({targets: [coin], duration: zoomTime, scale: 2, yoyo: true})
			.add({targets: [bkg, txt], alpha: 1, 
				duration: fadeTime, offset: 0,
				completeDelay: 2*zoomTime - fadeTime,
			})
			.add({targets: [coin], duration: fadeTime, alpha: 0, delay: pauseTime,
				completeDelay: moveTime - fadeTime,
				onStart: () => {
					store.coinAnimation = {
						from: coin.getTopLeft(),
						to: 'balanceCoin', 
						time: 1, //Math.min(0.01*baseScore, moveTime / 1000),
						value: baseScore, coins: 5
					}
					this.m.playAudio('Coins_v5c');
				},
			})
			.add({targets: [bkg, txt], duration: fadeTime,
				alpha: 0, offset: '-=' + fadeTime
			})		
		flow.play()		
	}

	startBonus = () => {
		console.log('4564 UI bonus prematch')
		store.isInBonusGame = true;
		this.popper.updateButtonColor(true)
		this.bonusGame.startBonus()
		this.tableClearing();
		store.showPatternButton = false;
	}
	endBonus = () => {
		console.log('4564 end bonus');
		store.isInBonusGame = false;
		this.popper.updateButtonColor(false)
		this.clearWinBanner();
	}
}